<div class="nova-barcode-modal-box">
    <button type="button" class="btn-close nova-barcode-modal-close" aria-label="닫기" (click)="activeModal.dismiss()"></button>
    @if (error) {
    <div class="text-danger small text-center px-2">{{ error }}</div>
    } @else {
    <np-barcode [value]="barcode" type="qrcode" [width]="130" [options]="{ eclevel: 'M', padding: 2 }" />
    }
</div>
